import { PlacesFoodsTab } from "./PlacesFoodsTabs/PlacesFoodsTabs.helpers";

/**
 * The Places/Foods tabs surface as soon as an include term is applied — and
 * stay visible while the user sits on the Foods tab, so removing the last term
 * reveals the "add a term" prompt instead of yanking the tabs (and the way
 * back) out from under them.
 */
export function shouldShowOnTheMenuTabs(
    includes: string[],
    activeTab: PlacesFoodsTab = "places",
): boolean {
    return includes.length > 0 || activeTab === "foods";
}

export function getOnTheMenuTerm(includes: string[]): string {
    return includes.join(', ');
}
